import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../utils/apiClient";
import { QUERY_CONFIG } from "../constants";

type EntitlementsResponse = {
  limits?: {
    is_copilot_enabled?: boolean;
  };
};

const QUERY_KEY = "entitlements";

export function useAccountEntitlements(accountId?: string | null) {
  // only run query when accountId is defined
  const enabled = Boolean(accountId);

  const { data, error, isInitialLoading } = useQuery({
    queryKey: [QUERY_KEY, accountId],
    queryFn: async (): Promise<EntitlementsResponse> => {
      const resp = await apiClient.getAccountEntitlements(String(accountId));
      return resp as EntitlementsResponse;
    },
    enabled,
    ...QUERY_CONFIG,
  });

  const isEnabled = data?.limits?.is_copilot_enabled;
  const isCopilotOptOut = isEnabled === false; // only explicit false means opted out

  return {
    // Use isInitialLoading instead of isLoading to handle disabled queries correctly
    // When enabled=false, isLoading returns true but isInitialLoading returns false
    // Only show loading on initial fetch, not on background refetches (prevents form unmount)
    isLoading: isInitialLoading,
    error: error as Error | null,
    isCopilotOptOut,
  } as const;
}
